import { useTranslation } from 'react-i18next';
import { routesMapDE, routesMapEN } from '../core/constants';
import { Lang } from '../core/types';

const SITE_URL =
  process.env.REACT_APP_ENV === 'prod'
    ? 'https://countx.com'
    : `https://www-${
        process.env.REACT_APP_ENV || process.env.NODE_ENV
      }.countx.com`;

export default function useLinkToMainSite() {
  const { i18n } = useTranslation();
  return {
    getLink: (k: string, language?: Lang) => {
      const currentLang = language || i18n.language;

      const routesMap: {
        [key: string]: string;
      } = currentLang === 'en' ? routesMapEN : routesMapDE;

      return SITE_URL + (routesMap[k] || k);
    },
  };
}
